<template>
  <div class="sp_view">
    <el-form ref="dynamicValidateForm" :model="dynamicValidateForm" class="demo-dynamic">
      <el-form-item
        prop="name"
      >
        <div style="display: flex; justify-content: left;">
          <div style="width: 100px;"> 标签组名称</div>
          <el-input v-model="dynamicValidateForm.group_name" />
        </div>

      </el-form-item>
      <el-form-item
        v-for="(domain, index) in dynamicValidateForm.domains"
        :key="index"
        :prop="domain.name"
      >
        <div style="display: flex; justify-content: space-between;">
          <div style="width: 110px;">标签</div>
          <el-input v-model="domain.name" />
          <i style="margin-left: 10px;font-size: 20px;line-height: 36px;" class="el-icon-delete" @click.prevent="removeDomain(domain)" />

        </div>

      </el-form-item>
      <el-form-item>

        <el-button icon="el-icon-plus" type="text" @click="addDomain">添加标签</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit()">确认</el-button>
      </el-form-item>
    </el-form>
    <!-- <div class="addbox">
      <span class="title">标签组名称</span>
      <el-input v-model="input" placeholder="标签组名称" />
    </div>

    <div class="addbox">
      <div>
        <span class="title">标签</span>
        <el-input v-model="input2" placeholder="标签名称" />
      </div>

      <div @click="addinput">
        +
        <span>添加标签</span>
      </div>
    </div>

    <div style="height: 147px;overflow-y: auto">
      <el-row v-for="(e, index) in fileNameList" :key="index">
        <el-col :span="19">
          <el-form-item label="名称" prop="folder" label-width="60px">
            <el-input v-model="e.fileName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <label class="exceptionHoles-delete" @click="deleteRow(index)">删除</label>
        </el-col>
      </el-row>
    </div>
    <el-button type="primary" @click="sumbit">确认</el-button> -->
  </div>

</template>

<script>
// import EnterChat from './EnterChat.vue'
// import addFriends from './addFriends.vue'
import { addCorpTag } from '@/api/numberTemplatemessage'
export default {
  // name: 'Label',
  components: {
    // EnterChat,
    // addFriends,
    // Approval: () => import('./Approval.vue')
    // Report: () => import('./report.vue')
  },
  data() {
    return {
      activeName: 'chat',
      input: '',
      input2: '',
      fileNameList: [{
        fileName: ''
      }],
      dynamicValidateForm: {
        domains: [{
          name: ''
        }],
        group_name: ''
      },
      corp_id: ''
    }
  },
  created() {
    this.corp_id = this.$route.query.id
    console.log('this.corp_id', this.corp_id)
  },
  mounted() {
  },
  activated() {

  },
  methods: {
    // send(row) {
    //   console.log('send---', row)
    // },
    async sumbit() {
      if (this.dynamicValidateForm.group_name === '') {
        this.$message.error('请输入标签组名称')
        return
      }
      for (var i = 0; i < this.dynamicValidateForm.domains.length; i++) {
        if (this.dynamicValidateForm.domains[i].name === '') {
          this.$message.error('请输入标签名称')
          return
        }
      }

      const data = await addCorpTag({
        corp_id: this.corp_id,
        group_name: this.dynamicValidateForm.group_name,
        tag: this.dynamicValidateForm.domains
      })
      console.log('data', data)
      this.$emit('updatlabel')
    },
    // addinput() {
    //   this.fileNameList.push({
    //     fileName: ''
    //   })
    // },

    // deleteRow(index) {
    //   // console.log('index', index)
    //   this.$confirmBox('确定删除？', '提示').then(() => {
    //     for (let i = 0; i < this.fileNameList.length; i++) {
    //       if (index === i) {
    //         this.fileNameList.splice(i, 1)
    //         this.$notify({
    //           title: '成功',
    //           message: '删除成功',
    //           type: 'success',
    //           duration: 2000
    //         })
    //       }
    //     }
    //   })
    // }
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        name: ''
      })
      // if (this.dynamicValidateForm.domains.length < 5) {
      //   this.dynamicValidateForm.domains.push({
      //   name: ''
      //   })
      // } else {
      //   this.$message.warning('标签不能超过5条')
      //   return
      // }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding:10px 20px;
}
.addbox{
  margin-bottom: 15px;
}
.title{
  line-height: 30px;
}
</style>
